/**
 * 登录页用户协议与隐私政策链接。
 *
 * 正文**不走 OSS 直链**：docx 会被浏览器直接下载而不是预览，达不到「展示正文」的目的。
 * 因此把 OSS 上的 docx 解析生成站内正文页（`pages/agreement/*Content.ts`），
 * 这里只登记对外路径，点击后在新标签页打开，不打断登录弹窗。
 *
 * 协议更新流程：替换 OSS 上的 docx → 重新生成正文数据文件 → 发版，路径常量无需改动。
 */
/** 用户服务条款站内路径。 */
export const USER_AGREEMENT_PATH = '/agreement/user-agreement';
/** 隐私政策站内路径。 */
export const PRIVACY_POLICY_PATH = '/agreement/privacy-policy';
